import { useEffect, useState } from "react";
import axios from "axios";
import { ministries as mockMinistries } from "../mock";
import { Link } from "react-router-dom";
import * as Lucide from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const defaultHp = {
  ministries_eyebrow: "Ministries",
  ministries_title_part1: "A place to",
  ministries_title_italic: "grow, serve, & belong.",
  ministries_subtitle: "From children\u2019s church to community outreach, there\u2019s a space where your gifts will be celebrated and your soul refreshed.",
};

export default function Ministries() {
  const [list, setList] = useState(mockMinistries);
  const [hp, setHp] = useState(defaultHp);
  useEffect(() => {
    axios.get(`${API}/ministries`).then(r => { if (r.data?.length) setList(r.data); }).catch(() => {});
    axios.get(`${API}/homepage`).then(r => { if (r.data) setHp({ ...defaultHp, ...r.data }); }).catch(() => {});
  }, []);

  return (
    <section id="ministries" className="py-24 md:py-28 bg-[#f5f7f9]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-14 gap-6">
          <div>
            <div className="text-[#c8a36a] uppercase tracking-[0.32em] text-xs font-bold mb-3">{hp.ministries_eyebrow}</div>
            <h2 className="text-4xl md:text-5xl font-bold text-[#0a2d38] max-w-xl leading-[1.05] tracking-tight">
              {hp.ministries_title_part1} <span className="text-[#c8a36a]">{hp.ministries_title_italic}</span>
            </h2>
          </div>
          <p className="max-w-md text-[#4a5b62] leading-relaxed">{hp.ministries_subtitle}</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {list.map((m, i) => {
            const Icon = Lucide[m.icon] || Lucide.Heart;
            return (
              <Link key={m.id || m.slug || i} to={`/ministries/${m.slug}`} className="group bg-white rounded-md p-8 border border-[#e8ecef] card-lift block">
                <div className="h-12 w-12 rounded-full bg-[#f5f2ec] border border-[#e7dfd0] flex items-center justify-center mb-6 group-hover:bg-[#c8a36a] group-hover:border-[#c8a36a] transition-colors">
                  <Icon className="h-5 w-5 text-[#0a2d38] group-hover:text-white" />
                </div>
                <h3 className="text-2xl font-bold text-[#0a2d38] mb-3">{m.title}</h3>
                <p className="text-[#4a5b62] leading-relaxed text-[15px]">{m.desc}</p>
                <div className="mt-6 inline-flex items-center gap-2 text-sm font-bold text-[#0a2d38] group-hover:text-[#c8a36a] transition-colors">
                  Learn more <Lucide.ArrowUpRight className="h-4 w-4" />
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
